import { Link } from "react-router-dom";
import { SocialProductsTable } from "./SocialProductsTable";

/**
 * MKT-1 · 上架中心「社媒（S4）」页签（契约 V1.1 §B：S1 后台「上架中心」加「社媒（S4）」页签，逐个产品开关，默认关）。
 * 内容 = 内容营销「产品开放」同一个组件（SocialProductsTable），两处改的是同一个开关。
 */
export function SocialListingTab() {
  return (
    <div className="mt-5 rounded-md border border-slate-200 bg-white" data-testid="listing-social-tab">
      <div className="flex flex-wrap items-center gap-2 border-b border-slate-200 px-3 py-2.5">
        <b className="text-slate-900">社媒（S4）开放</b>
        <span className="text-[12.5px] text-slate-400">哪些产品允许 S4 拿去发帖 · 默认关 · 关掉 = 对 S4 等于下架（没发出去的帖子会被拦住）</span>
        <span className="flex-1" />
        <Link to="/marketing" className="text-[13px] text-brand hover:underline">去内容营销看帖子 ›</Link>
      </div>
      <SocialProductsTable />
      <div className="px-3 py-2 text-[11.5px] text-slate-400">只有标了「实拍授权」的图才会被 S4 拿去发帖；没声明的不用。</div>
    </div>
  );
}
